export default __webpack_public_path__ + "static/thekinetixgroup-logo-5484c4c90cd98791e3d38210c7736c88.svg";